@if (!isHidden && !isMenuItem) {
  <forge-button [dense]="compact" variant="outlined" (click)="executeAction($event)"
    [disabled]="isViewOnly" attr.telemetry="Submission-{{Tooltip}}" tabindex="0" [fullWidth]="isFullWidth"
    (keydown)="handleKeyDown($event)">
    @if (hasIcon) {
      <forge-icon slot="start" [name]="ButtonIconName" [ngClass]="{'no-text-no-margin': Text === ''}">
      </forge-icon>
    }
    <span class="metadata-button-text">{{Text}}</span>
  </forge-button>
}

<!-- TODO Remove button and use ng-on-forge-list-item-select="action()" on the forge-list-item element when Forge 1.15 is released -->
@if (!isHidden && isMenuItem) {
  <button type="button" (click)="executeAction($event)" [disabled]="isViewOnly"
    attr.telemetry="Submission-{{Text}}" class="menu-item--button">
    <forge-list-item class="menu-item" [disabled]="isViewOnly" [ngStyle]="isViewOnly && {'pointer-events':'none'}">
      {{Text}}
    </forge-list-item>
  </button>
}